export default __webpack_public_path__ + "static/media/computer-min.a17df5d2.png";